import { PlusIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { ROUTE_PATTERNS } from "../../shared/routing/appPaths";
import AppButton from "../../ui/buttons/AppButton";
import ButtonLink from "../../ui/buttons/ButtonLink";
import { APP_SECTIONS } from "../appSections";
import { useWorkspace } from "./useWorkspace";

/** The new tab's choices (SH-1a); /threads owns starting a new Thread and its permission checks. */
export default function NewTabPage() {
  const { t } = useTranslation();
  const workspace = useWorkspace();
  return (
    <div className="mx-auto grid max-w-lg grid-cols-2 gap-3 py-12">
      <AppButton variant="primary" className="col-span-2" onClick={() => { workspace.open(ROUTE_PATTERNS.threads); }}>
        <PlusIcon className="h-5 w-5" aria-hidden="true" />{t("threads.prepare.run.newThread")}
      </AppButton>
      {APP_SECTIONS.map(({ id, path, labelKey, icon: Icon }) => (
        <ButtonLink key={id} to={path} size="md">
          <Icon className="h-5 w-5" aria-hidden="true" />{t(labelKey)}
        </ButtonLink>
      ))}
    </div>
  );
}
